import { CIcon } from '~/icons/types'

export const ciEdit: CIcon = {
  width: '15',
  height: '14',
  paths: [
    {
      d:
        'M13.467.533c-.667-.666-1.8-.666-2.467 0l-.8.8L12.667 3.8l.8-.8c.733-.667.733-1.8 0-2.467ZM3.933 7.6c-.4.4-.733.933-.866 1.467l-.534 1.8c-.066.2 0 .333.134.466.133.134.333.2.466.134l1.8-.534C5.467 10.8 6 10.467 6.4 10.067l5.6-5.6L9.533 2l-5.6 5.6Z'
    },
    {
      d:
        'M11 7.534c-.267 0-.533.2-.533.533v3.467c0 .533-.467 1-1 1h-7c-.534 0-1-.467-1-1V4.467c0-.533.466-1 1-1h3.466c.267 0 .534-.2.534-.533 0-.267-.2-.534-.534-.534H2.467c-1.134 0-2 .867-2 2v7c0 1.134.866 2 2 2h7c1.133 0 2-.866 2-2V7.934c.066-.2-.2-.4-.467-.4Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'edit',
  type: 'solid'
}
